import { Privileges } from '@/auth/enum/auth.enum';
import { getRequiredPrivilegeByPath } from '@/auth/routes/auth.routes';

export interface Categorie {
  title: string;
  icon: string;
  actionButtons: ActionButtonDefinition[];
}

interface ActionButtonDefinition {
  name: string;
  description: string;
  link: string;
  privilege: Privileges,
  showPending?: true,
}

export const actionButtonsCategories: Categorie[] = [
  {
    title: 'Aprobación de solicitudes',
    icon: 'assets/img/validar.png',
    actionButtons: [
      {
        name: 'Listado de solicitudes a aprobar',
        description: 'Nuevas, renovaciones y ampliaciones.',
        link: '/license/approve',
        privilege: getRequiredPrivilegeByPath('/license/approve'),
        showPending: true,
      },
      {
        name: 'Delegar aprobaciones pendientes',
        description: 'Traspasar listado a otra persona.',
        link: '/delegate',
        privilege: getRequiredPrivilegeByPath('/delegate'),
      },
      {
        name: 'Buscar conductor',
        description: 'Buscar por nombre, rut, correo.',
        link: '/search/driver',
        privilege: 'APPROVAL SEARCH',
      },
      {
        name: 'Actualizar licencia mina',
        description: 'Buscar por nombre, rut, correo.',
        link: '/license/mine',
        privilege: getRequiredPrivilegeByPath('/license/mine'),
      },
    ],
  },
  {
    title: 'Infracción',
    icon: 'assets/img/form.png',
    actionButtons: [
      {
        name: 'Ingresar una infracción',
        description: 'Formulario para infracción a conductor.',
        link: '/infractions/enter',
        privilege: getRequiredPrivilegeByPath('/infractions'),
      },
      {
        name: 'Buscar infracción por conductor',
        description: 'Buscar por nombre, rut, correo.',
        link: '/search/infraction',
        privilege: 'INFRINGEMENT SEARCH',
      },
      {
        name: 'Informe de infracciones',
        description: 'Infracciones por periodo y/o lugar.',
        link: '/reports/infractions',
        privilege: 'INFRINGEMENT VIEW_REPORT',
      },
    ],
  },
  {
    title: 'Solicitar',
    icon: 'assets/img/id.png',
    actionButtons: [
      {
        name: 'Crear solicitud nueva licencia',
        description: 'Formulario para empleados y contratistas.',
        link: '/license/new',
        privilege: getRequiredPrivilegeByPath('/license/new'),
      },
      {
        name: 'Renovar licencia',
        description: 'Acceso para renovar documentos o contrato.',
        link: '/license/renew',
        privilege: getRequiredPrivilegeByPath('/license/renew'),
      },
      {
        name: 'Ampliar licencia',
        description: 'Formulario para modificar equipos registrados.',
        link: '/license/extend',
        privilege: getRequiredPrivilegeByPath('/license/extend'),
      },
    ],
  },
  {
    title: 'Verificación',
    icon: 'assets/img/verificar.png',
    actionButtons: [
      {
        name: 'Licencias',
        description: 'Verificar estado de licencias.',
        link: '/verification/licenses',
        privilege: getRequiredPrivilegeByPath('/verification/licenses'),
      },
      {
        name: 'Solicitudes',
        description: 'Revisión del estado de solicitudes.',
        link: '/verification/requests',
        privilege: getRequiredPrivilegeByPath('/verification/requests'),
      },
      {
        name: 'Mis sanciones',
        description: 'Revisión del historial de sanciones.',
        link: '/verification/infractions',
        privilege: getRequiredPrivilegeByPath('/verification/infractions'),
      },
    ],
  },
];
